import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NationalityEntity } from './nationality.entity';
import { catchError, mergeMap, of, tap } from 'rxjs';
import { NationalityActions } from './nationality.actions';
import { ObjectNumber } from '../../type';

@Injectable()
export class NationalityEffects {
  private readonly actions$ = inject(Actions);

  private readonly init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NationalityActions.init),
      mergeMap(action => {
        const entities = action.nationalities.map<NationalityEntity>(nationality => NationalityEntity.fromJson(nationality));
        return of(NationalityActions.loadSuccess({ entities }));
      }),
      catchError(error => of(NationalityActions.loadFailure({ error })).pipe(tap(error => console.error(error)))),
    ),
  );

  private readonly loadingSingpassMap$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NationalityActions.loadSuccess),
      mergeMap(action => {
        const singpassMap = action.entities.reduce<ObjectNumber>((acc, entity) => {
          acc[entity.sibs === 'SG' ? 'singapore citizen' : entity.nationality.toLowerCase()] = entity.id;
          return acc;
        }, {});

        console.log(singpassMap);
        return of(NationalityActions.loadSingpassMap({ singpassMap }));
      }),
    ),
  );
}
